import poilibs from "./poi-libs/poi-libs.js";

export default poilibs;
